import { Menu } from "@headlessui/react";

export const WebPagesActionMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
	handlePublishWebPages,
	handleUpdateCDNWebPages,
	handleResetCDNForAll,
	handleDeleteCDNForAll,
	handleAddNewCardsForAllVendors,
	handleClickResetForAllVendors,
	handleClickDeleteForAllVendors
}) => {
    return (
        <>
		<Menu as="div" className="relative text-left">
									<div>
										<Menu.Button
											onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
											className="m-2 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="currentColor"
												viewBox="0 0 24 24"
												width="24"
												height="24"
											>
												<circle cx="12" cy="5" r="2" />
												<circle cx="12" cy="12" r="2" />
												<circle cx="12" cy="19" r="2" />
											</svg>
										</Menu.Button>
									</div>
									{anchorShipmentEl && (
										<Menu.Items className="absolute z-20 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
											<div className="px-1 py-1">
												{/* CDN Related Actions Section */}
												<div className="px-2 py-1 font-semibold text-gray-700 underline">CDN Related Actions</div>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handlePublishWebPages();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
															title="Publish Account web pages for all vendors in CDN"
														>
															Publish all vendors in CDN
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleUpdateCDNWebPages();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
															title="Add Newly updated Cards to the Web pages for all vendors already  published in CDN"
														>
															Add newcard for all vendors
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleResetCDNForAll();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
															title="To reset the Web pages for all vendors already published in CDN"
														>
															Reset all vendors in CDN
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleDeleteCDNForAll();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
															title="To delete  the Web pages for all vendors published in CDN"
														>
															Delete all vendors in CDN
														</button>
													)}
												</Menu.Item>
												<div className="px-2 py-1 font-semibold text-gray-700 underline">Webpages Related Actions</div>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleAddNewCardsForAllVendors();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}

															title='Add New Updated cards for all vendors as published in Platform Website'
														>
															Add New Cards to all Vendors
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleClickResetForAllVendors();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
															title='Reset the current website and create new records for all vendors  with Platform Website'
														>
															Reset webpage for all Vendors
														</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleClickDeleteForAllVendors();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-100' : ''
																} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}
															title="Delete Account web pages for all vendors"
														>
															Delete webpages for all Vendors
														</button>
													)}
												</Menu.Item>
											</div>
										</Menu.Items>
									)}
								</Menu>
        </>
    )
}